export default "__VITE_ASSET__V9BfX_T___"